import React, { useContext } from "react";
import "./FoodDisplay.css";
import { StoreContext } from "../Context/StoreContext";
import FoodItem from "./FoodItem";

const FoodDisplay = ({ category }) => {
  const { food_list } = useContext(StoreContext);
  return (
    <div className="food-display" id="food-display">
      <h2>Top dishes near you</h2>
      <div className="food-display-list">
        {food_list.map((item, index) => {
          if (category === "All" || category === item.category) {
            return (
              <FoodItem
                key={index}
                id={item._id}
                name={item.name}
                desc={item.description}
                price={item.price}
                image={item.image}
              />
            );
          }
          return null; // Ensure we return null if the condition is not met to avoid rendering undefined.
        })}
      </div>
    </div>
  );
};

export default FoodDisplay;
